import styled from 'styled-components';

import { Flex } from 'components/Flex';
import { Icon } from 'components/Icon/Icon';

export const SearchContextHeaderLinkText = styled(
  ({ text = 'previous', className }: { text: string; className?: string }) => (
    <Flex alignItems="center" className={className}>
      {(() => {
        switch (text) {
          case 'next':
            return (
              <>
                <span>{getText('Next')}</span>
                <Icon name="chevron-right" size={15} />
              </>
            );

          case 'previous':
          default:
            return (
              <>
                <Icon name="chevron-left" size={15} />
                <span>{getText('Previous')}</span>
              </>
            );
        }
      })()}
    </Flex>
  ),
)`
  > :not(:first-child) {
    margin-left: 5px;
  }

  svg {
    path,
    polyline {
      fill: currentcolor;
    }
  }
`;
